var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTaxDeclaration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14L15 8",
    stroke: "#8F27C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.5C9 8.63261 9.05268 8.75979 9.14645 8.85355C9.24021 8.94732 9.36739 9 9.5 9C9.63261 9 9.75979 8.94732 9.85355 8.85355C9.94732 8.75979 10 8.63261 10 8.5C10 8.36739 9.94732 8.24021 9.85355 8.14645C9.75979 8.05268 9.63261 8 9.5 8C9.36739 8 9.24021 8.05268 9.14645 8.14645C9.05268 8.24021 9 8.36739 9 8.5ZM14 13.5C14 13.6326 14.0527 13.7598 14.1464 13.8536C14.2402 13.9473 14.3674 14 14.5 14C14.6326 14 14.7598 13.9473 14.8536 13.8536C14.9473 13.7598 15 13.6326 15 13.5C15 13.3674 14.9473 13.2402 14.8536 13.1464C14.7598 13.0527 14.6326 13 14.5 13C14.3674 13 14.2402 13.0527 14.1464 13.1464C14.0527 13.2402 14 13.3674 14 13.5Z",
    fill: "#8F27C7",
    stroke: "#8F27C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21L16 19L14 21L12 19L10 21L8 19L5 21Z",
    stroke: "#8F27C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTaxDeclaration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tax-declaration.ac059d6b0186287f83dd9f35e972960e.svg";